export const isFrameUser = window !== window.parent.frames;
